import { z } from 'zod';

import { NachaPaymentInfo } from '../events/NachaPaymentInfo';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const CreateNachaTransactionSideEffectContext = BaseLoanIdSideEffect.extend(NachaPaymentInfo.shape);
export const CreateNachaTransactionSideEffect = CreateNachaTransactionSideEffectContext.extend({
  type: z.literal('createNachaTransaction'),
});
export type CreateNachaTransactionSideEffect = z.infer<typeof CreateNachaTransactionSideEffect>;
